__turbopack_context__.v({
  "className": "plus_jakarta_sans_f78dcf7c-module__qsbJmG__className",
});
